<template>
  <div class="language-switcher">
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn aria-label="Zmień język" icon="mdi mdi-google-translate" variant="text" v-bind="props">
            {{ currentLangSymbol() }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="changeLanguage('pl')">
            <v-list-item-title>PL</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('en')">
            <v-list-item-title>EN</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('de')">
            <v-list-item-title>DE</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('uk')">
            <v-list-item-title>UK</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import store from '@/store';
import { useLocale } from "vuetify";
import * as CookieConsent from "vanilla-cookieconsent";

const LanguageSwitcher: object = defineComponent({
  props: {

  },
  setup() {
    const locale = useLocale();
    // const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    // const handleContrastClick = () => store.commit('flipContrastActive');

    const changeLanguage = (langKey: string) => {
      CookieConsent.setLanguage(langKey);
      switch (langKey) {
        case 'pl':
          store.commit('flipLanguage', 0);
          locale.current.value = 'pl';
          break;
        case 'en':
          store.commit('flipLanguage', 1);
          locale.current.value = 'en';
          break;
        case 'de':
          store.commit('flipLanguage', 2);
          locale.current.value = 'de';
          break;
        case 'uk':
          store.commit('flipLanguage', 3);
          locale.current.value = 'uk';
          break;
        default:
          store.commit('flipLanguage', 0);
          locale.current.value = 'pl';
          break;
      }
    };

    const currentLangSymbol = () => {
      const langIndex: number = store.getters.getCurrentLang;
      switch (langIndex) {
        case 0:
          return 'PL';
        case 1:
          return 'EN';
        case 2:
          return 'DE';
        case 3:
          return 'UK';
        default:
          return 'PL';
      }
    };

    onMounted(() => { 
      // set current language for cookie consent
      CookieConsent.setLanguage(currentLangSymbol().toLowerCase());
    });

    return {
      changeLanguage,
      currentLangSymbol,  
    };
  },
});
export default LanguageSwitcher;
</script>


<style scoped lang="scss">


</style>
